import { InformativeCardVariantType } from '../../../../../../components/informativeCard/types/informativeCard';
import { InformativeCardOrientation } from '../../../../../../components/informativeCard/types/orientation';
import { TagVariantType } from '../../variants';
import { descriptionCommonStyles, iconCommonStyles, infoContainerVerticalCommonStyles, labelCommonStyles, parentContainerHorizontalCommonStyles, parentContainerVerticalCommonStyles, titleCommonStyles, } from '../commonStyles';
export const getUrgentStyles = (FOUNDATIONS, FONT) => {
    return {
        [InformativeCardVariantType.URGENT]: {
            [InformativeCardOrientation.HORIZONTAL]: {
                parentContainer: {
                    ...parentContainerHorizontalCommonStyles(FOUNDATIONS, FONT),
                    background_color: FOUNDATIONS.color_comp_content_informativecard_urgent_bg,
                },
                icon: {
                    ...iconCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_feedback_success_icon_50,
                },
                label: {
                    ...labelCommonStyles(FOUNDATIONS, FONT),
                },
                title: {
                    ...titleCommonStyles(FOUNDATIONS, FONT),
                },
                description: {
                    ...descriptionCommonStyles(FOUNDATIONS, FONT),
                },
                tag: {
                    variant: TagVariantType.SUCCESS,
                },
            },
            [InformativeCardOrientation.VERTICAL]: {
                parentContainer: {
                    ...parentContainerVerticalCommonStyles(FOUNDATIONS, FONT),
                    background_color: FOUNDATIONS.color_comp_content_informativecard_urgent_bg,
                },
                infoContainer: {
                    ...infoContainerVerticalCommonStyles(FOUNDATIONS, FONT),
                },
                icon: {
                    ...iconCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_feedback_success_icon_50,
                },
                label: {
                    ...labelCommonStyles(FOUNDATIONS, FONT),
                    text_align: 'center',
                },
                title: {
                    ...titleCommonStyles(FOUNDATIONS, FONT),
                    text_align: 'center',
                },
                description: {
                    ...descriptionCommonStyles(FOUNDATIONS, FONT),
                    text_align: 'center',
                },
                tagContainer: {
                    margin_top: FOUNDATIONS.spacing_150,
                },
                tag: {
                    variant: TagVariantType.SUCCESS,
                },
            },
        },
    };
};
//# sourceMappingURL=urgent.js.map